import React from 'react';
import { resolveStyle } from './base_components';

type Props = {
  style?: any;
  value: string;
  options: any[];
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  children?: any;
};
export default function Select(props: Props) {
  const {
    style,
    value,
    options,
    placeholder,
    className: extraClass,
    onChange,
    children,
    ...other_props
  } = props;
  function _onChange(e: any) {
    onChange?.(e.target.value);
  }

  const opts = options.map(_mapOpt);
  if (placeholder && !value) {
    const def = (
      <option key='default' disabled hidden value=''>
        {placeholder}
      </option>
    );
    opts.unshift(def);
  }

  const { className, inlineStyle } = resolveStyle(style, extraClass);
  return (
    <select
      className={'base-component-text-input ' + className}
      style={inlineStyle}
      {...other_props}
      value={String(value)}
      onChange={_onChange}
    >
      {opts}
      {children}
    </select>
  );
}
function _mapOpt(opt: any, i: number) {
  let ret;
  if (typeof opt === 'string') {
    ret = (
      <option key={i} value={opt}>
        {opt}
      </option>
    );
  } else if (opt.value !== undefined && opt.text !== undefined) {
    ret = (
      <option key={i} value={String(opt.value)}>
        {opt.text}
      </option>
    );
  }
  return ret;
}
